import { IGame } from '../types/game';
import { GameCancelledModal } from '../ui/GameCancelledModal/GameCancelledModal';
import { GameConflictModal } from '../ui/GameConflictModal';
import { MatchCountdownWidget } from '../ui/MatchCountdown';
import { NetworkProblems } from '../ui/NetworkProblems/NetworkProblems';
import { useGameConflictModal } from './useGameConflictModal';

export function useGameModal(gameId: string | undefined, networkProblems: boolean, game?: IGame) {
  // Модалка "Начинается партия в другом турнире"
  const gameConflict = useGameConflictModal(gameId);
  // Выбор модалки
  const modal = (function () {
    if (gameConflict) return <GameConflictModal {...gameConflict} />;
    if (networkProblems) return <NetworkProblems />;

    switch (game?.result) {
      case 'NotStarted':
        return <MatchCountdownWidget game={game} />;
      case 'NotPlayed':
        return <GameCancelledModal />;
    }
  })();

  return modal;
}
